<template>
  <Container judul="Galeri">
    <template #header>
      <HeaderFe />
    </template>
    <template #hero>
      <PageHero page="galeri" title="Galeri Kegiatan" current="Galeri"
        subtitle="Dokumentasi kegiatan dan momen penting." />
    </template>
    <template v-slot:default>
      <div class="min-h-screen pb-16 bg-gray-50/40">
        <!-- Grid -->
        <section class="mt-12">
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <div
              v-if="galleries.data && galleries.data.length > 0"
              class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3"
            >
              <article
                v-for="gallery in galleries.data"
                :key="gallery.id"
                class="flex flex-col overflow-hidden transition-all duration-300 bg-white border border-gray-100 shadow-sm group rounded-2xl hover:shadow-lg hover:-translate-y-1"
              >
                <button
                  type="button"
                  @click="openGallery(gallery)"
                  class="relative block overflow-hidden aspect-[16/10] bg-gray-100 focus:outline-none"
                >
                  <img
                    v-if="firstImage(gallery.image_path)"
                    :src="firstImage(gallery.image_path)"
                    :alt="gallery.title"
                    class="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
                  />
                  <div
                    v-else
                    class="flex items-center justify-center w-full h-full text-gray-300"
                  >
                    <i class="text-4xl fa-regular fa-image"></i>
                  </div>
                  <span
                    v-if="imageCount(gallery.image_path) > 1"
                    class="absolute inline-flex items-center gap-1 px-2.5 py-1 text-xs font-semibold text-white rounded-full top-3 right-3 bg-black/60 backdrop-blur-sm"
                  >
                    <i class="fa-regular fa-images"></i>
                    {{ imageCount(gallery.image_path) }}
                  </span>
                  <span
                    class="absolute inset-0 flex items-center justify-center transition-opacity duration-300 opacity-0 bg-black/30 group-hover:opacity-100"
                  >
                    <span
                      class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-900 bg-white rounded-full shadow"
                    >
                      <i class="fa-solid fa-magnifying-glass-plus"></i>
                      Lihat
                    </span>
                  </span>
                </button>

                <div class="flex flex-col flex-1 p-5">
                  <h3
                    class="text-lg font-bold leading-snug text-gray-900 transition-colors cursor-pointer line-clamp-2 group-hover:text-primary font-roboto-slab"
                    @click="openGallery(gallery)"
                  >
                    {{ gallery.title }}
                  </h3>
                  <p class="flex-1 mt-2 text-sm text-gray-500 line-clamp-3">
                    {{ gallery.description }}
                  </p>
                </div>
              </article>
            </div>

            <!-- Empty state -->
            <div
              v-else
              class="flex flex-col items-center justify-center px-4 py-20 text-center bg-white border border-gray-100 rounded-2xl"
            >
              <i class="mb-4 text-4xl text-gray-300 fa-regular fa-images"></i>
              <h3 class="mb-1 text-lg font-semibold text-gray-900">
                Galeri belum tersedia
              </h3>
              <p class="max-w-sm text-sm text-gray-500">
                Belum ada galeri kegiatan yang tersedia saat ini.
              </p>
            </div>
          </div>
        </section>
      </div>
    </template>
    <template #footer>
      <FooterFe />
    </template>
  </Container>
</template>

<script setup>
import { defineProps } from "vue";
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import PageHero from "@/Components/Web/PageHero.vue";
import FooterFe from "@/Components/FooterFe.vue";
import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.min.css";

let glightboxInstance = null;

defineProps({
  galleries: {
    type: Object,
    required: true,
  },
});

const firstImage = (path) => {
  if (Array.isArray(path)) return path[0] || null;
  if (typeof path === "string" && path) return path;
  return null;
};

const imageCount = (path) => (Array.isArray(path) ? path.length : path ? 1 : 0);

const openGallery = (gallery) => {
  if (!Array.isArray(gallery.image_path) || gallery.image_path.length === 0) {
    alert("Galeri ini tidak memiliki gambar.");
    return;
  }

  const galleryItems = gallery.image_path.map((img) => ({
    href: img,
    type: "image",
    title: `<h4>${gallery.title}</h4><p>${gallery.description}</p>`,
  }));

  if (glightboxInstance) {
    glightboxInstance.destroy();
  }

  glightboxInstance = GLightbox({
    elements: galleryItems,
    touchNavigation: true,
    loop: true,
    zoomable: true,
    autoplayVideos: false,
  });

  glightboxInstance.open();
};
</script>
